<script setup lang="ts">
import { computed } from 'vue'

interface TProps {
  text?: string
  fill?: string
  stroke?: string
  strokeWidth?: number
  addCss?: string
  sizeCss?: string
}

const props = withDefaults(defineProps<TProps>(), {
  text: 'xx',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  addCss: '',
  sizeCss: '',
})

const wrapperCssClass = computed((): string => {
  const result = ['flex items-center']
  result.push(`${props.addCss || ''}`.trim())
  result.push(`${props.sizeCss || ''}`.trim())
  return [...new Set(result)].join(' ').trim()
})

const style = `${(props.sizeCss || '').trim()}`.trim().length === 0 ? 'width:1.75rem;height:1.75rem;' : ''
</script>

<template>
  <span :class="wrapperCssClass">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="100%"
      height="100%"
      :style="style"
      :fill="fill"
      :stroke="stroke"
      :stroke-width="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g id="squircle-layer" transform="matrix(1.22554,0,0,1.22554,-2.70342,-2.70643)">
        <path d="M12,3C19.2,3 21,4.8 21,12C21,19.2 19.2,21 12,21C4.8,21 3,19.2 3,12C3,4.8 4.8,3 12,3" />
      </g>
      <text
        dominant-baseline="hanging"
        text-anchor="middle"
        x="49.5%"
        y="24.5%"
        :fill="stroke"
        style="font-size: 0.8rem; letter-spacing: -0.05em"
        stroke-width="0"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        {{ text }}
      </text>
    </svg>
  </span>
</template>
